var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{staticClass:"password__modal alert-modal wafmodal",attrs:{"visible":_vm.getWAFModalSetting.visible,"closable":true,"footer":null,"width":850},on:{"cancel":_vm.closeWAFModalModal}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getWAFModalSetting.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }